export default __webpack_public_path__ + "static/media/btp-2-rMIN.17fe2115.avif";